Handlebars.templates = {
    video : {
        small : require("./templates/premium.video.small.hbs")
    },
    card : {
        normal : require("./templates/premium.card.hbs")
    },
    group : {
        fascia : require("./templates/premium.group.fascia.hbs"),
        spalla : require("./templates/premium.group.spalla.hbs")
    }
};


Handlebars.registerPartial("cards", require("./templates/premium.card.hbs"));
Handlebars.registerPartial("related", require("./templates/premium.video.small.hbs"));

require("../../../../rairadio/template/helpers/conditional-helpers.js");
require("../../../../rairadio/template/helpers/date-format-helper.js");
require("../../../../rairadio/template/helpers/images-helper.js");
require("../../../../rairadio/template/helpers/time-helper.js");
require("../handlebars/helpers/string");




// WEBPACK FOOTER //
// ./premium/tpls.js